module.exports = __webpack_public_path__ + "img/img_deposit_banner02.f6286714.png";